import React from "react";
import { BrowserRouter as Router, Routes as RouterRoutes, Route } from "react-router-dom";
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import HelperDiscovery from "./pages/helper-discovery";
import BookingScheduling from "./pages/booking-scheduling";
import SessionRoom from "./pages/session-room";
import SeekerIntakeFlow from "./pages/seeker-intake-flow";
import HelperProfileManagement from "./pages/helper-profile-management";
import PersonalDashboard from "./pages/personal-dashboard";
import AdminConsole from "./pages/admin-console";
import OrganizationLanding from "./pages/organization-landing";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import SystemPerformanceDashboard from "./pages/system-performance-dashboard";
import SubscriptionManagement from "./pages/subscription-management";

const Routes = () => {
  return (
    <Router>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<OrganizationLanding />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/helper-discovery" element={<HelperDiscovery />} />
          <Route path="/booking-scheduling" element={<BookingScheduling />} />
          <Route path="/session-room" element={<SessionRoom />} />
          <Route path="/seeker-intake-flow" element={<SeekerIntakeFlow />} />
          <Route path="/helper-profile-management" element={<HelperProfileManagement />} />
          <Route path="/personal-dashboard" element={<PersonalDashboard />} />
          <Route path="/admin-console" element={<AdminConsole />} />
          <Route path="/system-performance-dashboard" element={<SystemPerformanceDashboard />} />
          <Route path="/subscription-management" element={<SubscriptionManagement />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </Router>
  );
};

export default Routes;